import { render, staticRenderFns } from "./AppEditGeneral.vue?vue&type=template&id=63a16cb0&scoped=true"
import script from "./AppEditGeneral.vue?vue&type=script&lang=js"
export * from "./AppEditGeneral.vue?vue&type=script&lang=js"
import style0 from "./AppEditGeneral.vue?vue&type=style&index=0&id=63a16cb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a16cb0",
  null
  
)

export default component.exports